import { AdminClientApi } from '../Admin-ClientLibrary';
import { getApiUrl } from '../config/api';

let globalAdminApi: AdminClientApi | null = null;

export const getAdminApi = (): AdminClientApi => {
  if (!globalAdminApi) {
    const getToken = (): string => {
      return localStorage.getItem('authToken') || '';
    };

    globalAdminApi = new AdminClientApi(getApiUrl(), getToken);
  }

  return globalAdminApi;
};

export const setUnauthorizedHandler = (handler: () => void) => {
  const api = getAdminApi();
  api.setUnauthorizedHandler(handler);
};

// Create a new instance for components that need it
export const createAdminApi = () => {
  const getToken = (): string => {
    return localStorage.getItem('authToken') || '';
  };

  return new AdminClientApi(getApiUrl(), getToken);
};